import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CreateCourseEmbeddingsState {
    message: any;
    isLoading: boolean;
    error: string | null;
}

const initialState: CreateCourseEmbeddingsState = {
    message: null,
    isLoading: false,
    error: null,
};

const createCourseEmbeddingsSlice = createSlice({
    name: "createCourseEmbeddings",
    initialState,
    reducers: {
        createCourseEmbeddings: (state: CreateCourseEmbeddingsState, action: PayloadAction<any>) => {
            state.message = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setloading: (state: CreateCourseEmbeddingsState, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state: CreateCourseEmbeddingsState, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetCreateCourseEmbeddings: () => initialState,
    },
});

export const {
    createCourseEmbeddings,
    setloading,
    seterror,
    resetCreateCourseEmbeddings,
} = createCourseEmbeddingsSlice.actions;

export default createCourseEmbeddingsSlice.reducer;


